


















































































































































































































/* eslint-disable import/extensions */
import { Component, Vue } from 'vue-property-decorator';
import { round } from 'lodash-es';
import Loader from '~/components/shared/Loader.vue';
import Logo from '~/components/shared/Logo.vue';
import formatScore from '~/utils/format-score';
import share from '~/utils/share';
import meta from '~/meta';
import LibraryIcon from '~/components/shared/LibraryIcon.vue';
import copyToClipboard from '~/utils/copy-to-clipboard';
import notification from '~/ui/utils/notification';
import YearFactsChart from '~/components/shared/YearFactsChart.vue';

// @ts-ignore
// eslint-disable-next-line
import data from '~/assets/2020/fun_facts_merged.json';

const ScrollIcon = {
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
  render(): any {
    // @ts-ignore
    const h = this.$createElement;
    return h(
      'svg',
      {
        attrs: {
          width: 20,
          height: 28,
          viewBox: '0 0 20 28',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg',
        },
      },
      [
        h('path', {
          attrs: {
            d:
              'M10.013 23.5235L5.10376 18.3338L6.6929 16.8305L10.0088 20.3358L13.305 16.8326L14.8982 18.3316L10.013 23.5235ZM19.0781 21.4375V6.5625C19.0781 2.94394 16.1342 0 12.5156 0H7.48438C3.86581 0 0.921875 2.94394 0.921875 6.5625V21.4375C0.921875 25.0561 3.86581 28 7.48438 28H12.5156C16.1342 28 19.0781 25.0561 19.0781 21.4375ZM12.5156 2.1875C14.9281 2.1875 16.8906 4.15005 16.8906 6.5625V21.4375C16.8906 23.8499 14.9281 25.8125 12.5156 25.8125H7.48438C5.07193 25.8125 3.10938 23.8499 3.10938 21.4375V6.5625C3.10938 4.15005 5.07193 2.1875 7.48438 2.1875H12.5156ZM10 4.42969C9.39587 4.42969 8.90625 4.91931 8.90625 5.52344C8.90625 6.12756 9.39587 6.61719 10 6.61719C10.6041 6.61719 11.0938 6.12756 11.0938 5.52344C11.0938 4.91931 10.6041 4.42969 10 4.42969ZM10 8.80469C9.39587 8.80469 8.90625 9.29431 8.90625 9.89844C8.90625 10.5026 9.39587 10.9922 10 10.9922C10.6041 10.9922 11.0938 10.5026 11.0938 9.89844C11.0938 9.29431 10.6041 8.80469 10 8.80469ZM10 13.1797C9.39587 13.1797 8.90625 13.6693 8.90625 14.2734C8.90625 14.8776 9.39587 15.3672 10 15.3672C10.6041 15.3672 11.0938 14.8776 11.0938 14.2734C11.0938 13.6693 10.6041 13.1797 10 13.1797Z',
            // @ts-ignore
            fill: this.color,
          },
        }),
      ],
    );
  },
};

@Component({
  components: {
    Loader,
    Logo,
    LibraryIcon,
    ScrollIcon,
    YearFactsChart,
  },
  layout: 'empty',
})
export default class extends Vue {
  async fetch({ store }: any) {
    try {
      await store.dispatch('tryToGetAccount');
    } catch (err) {
      // error captured in store
    }
  }

  swiper: any = undefined;
  languageColors1 = ['#387EED', '#fff', '#512DA8', '#1E9700', '#EE3535'];
  languageColors2 = ['#FFB300', '#fff', '#512DA8', '#1E9700', '#EE3535'];
  data: any = data;
  activeSections: string[] = [];
  sectionAnimationProgress: any = {};

  head() {
    // TODO: Change meta
    return meta({
      title: `CodersRank - Year in Review 2020 - Fun Facts Edition`,
      description: 'Ready for your yearly summary in coding?',
      // eslint-disable-next-line
      image: require('~/assets/images/2020/share/facts.jpg'),
    });
  }

  get topOrgs() {
    return {
      max: Math.max(...data.open_source_organizations.map((item: any) => item.commit_count_total)),
      values: data.open_source_organizations.map((item: any) =>
        this.animatableNumber('slide-activity-chart', item.commit_count_total),
      ),
      labels: data.open_source_organizations.map((item: any) => item.email_domain),
      colors: this.languageColors1,
    };
  }

  get topRepos() {
    return {
      max: Math.max(...data.most_starred_repos.map((item: any) => item.star_count)),
      values: data.most_starred_repos.map((item: any) => this.animatableNumber('slide-top-repos', item.star_count)),
      labels: data.most_starred_repos.map((item: any) => item.repo_name),
      colors: this.languageColors1,
    };
  }

  get topNewRepos() {
    return {
      max: Math.max(...data.most_starred_new_repos.map((item: any) => item.star_count)),
      values: data.most_starred_new_repos.map((item: any) =>
        this.animatableNumber('slide-portfolio', item.star_count),
      ),
      labels: data.most_starred_new_repos.map((item: any) => item.repo_name),
      colors: this.languageColors2,
    };
  }

  get topBackendFrameworks() {
    return {
      max: Math.max(...data.backend_frameworks.map((item: any) => item.star_count)),
      values: data.backend_frameworks.map((item: any) =>
        this.animatableNumber('slide-self-improvement', item.star_count),
      ),
      labels: data.backend_frameworks.map((item: any) => item.repo_name),
      colors: this.languageColors2,
    };
  }

  get topJavaScriptFrameworks() {
    return {
      max: Math.max(...data.javascript_frameworks.map((item: any) => item.star_count)),
      values: data.javascript_frameworks.map((item: any) => this.animatableNumber('slide-sources', item.star_count)),
      labels: data.javascript_frameworks.map((item: any) => item.repo_name),
      colors: this.languageColors2,
    };
  }

  get topCities() {
    return {
      max: Math.max(...data.most_active_cities_df.map((item: any) => item.commit_count_total)),
      values: data.most_active_cities_df.map((item: any) =>
        this.animatableNumber('slide-certificates', item.commit_count_total),
      ),
      labels: data.most_active_cities_df.map((item: any) => item.city),
      colors: this.languageColors2,
    };
  }

  async mounted() {
    const [{ default: Swiper }] = await Promise.all([
      import(/* webpackChunkName: "swiper" */ 'swiper'),
      import(/* webpackChunkName: "swiper" */ 'swiper/css/swiper.css'),
    ]);

    this.$nextTick(() => {
      this.swiper = new Swiper({
        el: this.$el,
        direction: 'vertical',
        slidesPerView: 'auto',
        speed: 600,
        simulateTouch: false,
        parallax: true,
        mousewheel: {
          enabled: true,
          sensitivity: window.navigator.platform === 'Win32' || window.navigator.platform === 'Win64' ? 1.5 : 1,
        },
        keyboard: {
          enabled: true,
        },
        on: {
          transitionEnd: () => {
            if (!this.swiper) return;
            const sectionId = this.swiper.slides.eq(this.swiper.activeIndex).attr('id');
            if (sectionId) this.activateSection(sectionId);
          },
        },
      });
    });
  }

  activateSection(section: string) {
    if (this.activeSections.indexOf(section) >= 0) return;
    this.activeSections.push(section);
    // @ts-ignore
    this.$el.querySelector(`#${section}`).classList.add('year-2020-slide-activated');
    this.$set(this.sectionAnimationProgress, section, 0);
    const startTime = Date.now();
    const duration = 800;
    const render = () => {
      const timeDiff = Date.now() - startTime;
      if (timeDiff >= duration) {
        this.$set(this.sectionAnimationProgress, section, 1);
        return;
      }
      this.$set(this.sectionAnimationProgress, section, timeDiff / duration);
      requestAnimationFrame(render);
    };
    requestAnimationFrame(render);
  }

  animatableNumber(section: string, target: number) {
    if (this.activeSections.indexOf(section) < 0) return 0;
    return Math.round(this.sectionAnimationProgress[section] * target);
  }

  slideNext() {
    if (this.swiper) this.swiper.slideNext();
  }

  beforeDestroy() {
    if (this.swiper && this.swiper.destroy) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }

  formatNumber(number: number) {
    return formatScore(number);
  }

  formatScore(score: number) {
    return formatScore(round(score));
  }

  formatThousands(number: number): number | string {
    if (number > 1999999) {
      const precision = number > 10000000 ? 0 : 1;
      return `${this.formatNumber(round(number / 1000000, precision))}M`;
    }
    if (number > 9999) {
      return `${this.formatNumber(Math.round(number / 1000))}K`;
    }
    return this.formatNumber(number);
  }

  // TODO: Change sharing titles

  shareTwitter() {
    share.twitter(
      `https://profile.codersrank.io/year-in-review-2020/global/?utm_source=twitter&utm_medium=social&utm_campaign=2020_summary`,
      'CodersRank - Year in Review 2020 - Fun Facts Edition',
    );
  }

  shareFacebook() {
    share.facebook(
      `https://profile.codersrank.io/year-in-review-2020/global/?utm_source=facebook&utm_medium=social&utm_campaign=2020_summary`,
      'CodersRank - Year in Review 2020 - Fun Facts Edition',
    );
  }

  shareLinkedin() {
    share.linkedin(
      `https://profile.codersrank.io/year-in-review-2020/global/?utm_source=linkedin&utm_medium=social&utm_campaign=2020_summary`,
      'CodersRank - Year in Review 2020 - Fun Facts Edition',
    );
  }

  shareCopyUrl() {
    copyToClipboard(`https://profile.codersrank.io/year-in-review-2020/global/`, () => {
      notification({ text: 'URL copied to clipboard' });
    });
  }
}
